import $ from 'jquery';
import React, { PropTypes } from 'react';
import ReactDOMServer from 'react-dom/server';

export default function bind() {}

export const displayConfirmModalIfNeeded = (hasRights, callback) => {
  const title = 'Confirmation';
  const confirmationContent =
    "La validation du bilan va entraîner la génération du compte rendu d'intervention qui sera envoyé à votre client. Cette action est irréversible.";

  const renderActions = (
    <div className="actions">
      <div className="ui approve primary button">Valider</div>
      <div className="ui cancel button">Annuler</div>
    </div>
  );

  if (!hasRights) {
    displayConfirmModal(title, confirmationContent, renderActions, callback);
  } else {
    const modalContent =
      confirmationContent +
      '<br /><br />' +
      `<p style="color: red;">Attention, le client n'a pas de mail de contact. Il ne recevra donc pas le compte rendu.</p>`;
    displayConfirmModal(title, modalContent, renderActions, callback);
  }
};

function displayConfirmModal(title, content, actions, callback) {
  // Display modal
  const modal = ReactDOMServer.renderToStaticMarkup(
    <ConfirmModal title={title} content={content} actions={actions} />
  );
  displayModal(modal, callback);
}

function displayModal(modal, callback) {
  // Appending content to body
  $(document.body).append(modal);

  // Handling approve button
  const $modal = $('#confirm-action-modal');

  $modal
    .modal({
      onApprove: element => {
        // Execute action and hiding it on executed
        callback();

        return true;
      },
    })
    .modal('show');
}

const ConfirmModal = ({ title, content, haveWarningIcon = true, actions }) => {
  const renderActions = actions ? (
    actions
  ) : (
    <div className="actions">
      <div className="ui primary approve button">Confirmer</div>
      <div className="ui cancel button">Annuler</div>
    </div>
  );
  return (
    <div id="confirm-action-modal" className="ui small modal">
      <div className="header">
        {haveWarningIcon && <i className="icon warning circle" />}
        {title}
      </div>
      <div className="content" style={{ marginBottom: '20px' }}>
        <p dangerouslySetInnerHTML={{ __html: content }} />
      </div>
      {renderActions}
    </div>
  );
};

ConfirmModal.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  haveWarningIcon: PropTypes.bool,
  actions: PropTypes.element,
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/interventions/confirm-validation.js